$(document).ready(function () {

	const state = {
		zip: parseInt(localStorage.getItem("zipcode")) || null
	};

	function QuoteForm () {
		state.zipData = null;

		let $quoteForm = $('.sb-quote-form');
		
		function validateZip ($input) {
			if ($input) {
				if ($input.val().toString().length == 5) {
					let entry = state.zipData.find(item => item.zip == $input.val());
					let schedule = entry["Shipment Schedule"];

					if (entry && schedule && schedule != 'No shipment') {
						state.zip = entry.zip;
						state.schedule = schedule;
						return true;
					}
				}
			}
			return false;
		}

		$quoteForm.each(function () {
			let $input = $(this).find('.sb-quote-form__input');

			$(this).submit(function (e) {
				e.preventDefault();
				let zipCode = $input.val();

				$.get( "//www.getpestremedy.com/cdn/shop/t/22/assets/zipcodes.json?v=120884804956811048891773269411").done(function (data) {
					state.zipData = data;
					
					localStorage.setItem('zipcode', zipCode);
					if (validateZip($input)) {
						setTimeout(function () {
							let url = (state.schedule == 'Bi-monthly') ? '/products/HS1-BM-PAYG' : '/products/HS1-MO-PAYG';
							location.href = url;
						}, 500);
					} else {
						location.href = '/pages/zip-code#zip-error';
					}
				});
			});
		});
	}

	function ZipPage () {
		state.zipData = null;

		let $input = $('.sb-quiz-page__zip-input');
		let $message = $('.sb-quiz-page__message');
		let $nextBtn = $('.sb-quiz-page__next-btn');

		// Populate input if zip code exists
		if (state.zip) {
			$input.val(state.zip);
		}

		// Show message when newsletter form has been submitted
		if (location.hash == '#zip-error') {
			$message.show();
			$message.css('visibility', 'visible');
		}

		function enableNextBtn () {
			let url = (state.schedule == 'Bi-monthly') ? '/products/HS1-BM-PAYG' : '/products/HS1-MO-PAYG';
			$nextBtn.attr('href', url).removeClass('disabled');
		}

		function disableNextBtn () {
			$nextBtn.attr('href', 'javascript:;').addClass('disabled');
		}

		function validateZip () {
			if ($input.val().toString().length == 5) {
				let entry = state.zipData.find(item => item.zip == $input.val());
				if (!entry) {
					return;
				}
				let schedule = entry["Shipment Schedule"];

				if (!schedule) {
					state.zip = null;
					disableNextBtn();
					$message.hide();
				} else if (schedule == 'No shipment') {
					state.zip = null;
					disableNextBtn();
					$message.show();
					$message.css('visibility', 'visible');
				} else {
					state.zip = entry.zip;
					state.schedule = schedule;
					enableNextBtn();
					$message.hide();
					return true;
				}
			} else {
				disableNextBtn();
				$message.hide();
			}
			return false;
		}

		$.get( "//www.getpestremedy.com/cdn/shop/t/22/assets/zipcodes.json?v=120884804956811048891773269411").done(function (data) {
			state.zipData = data;
			validateZip();
			$input.on('propertychange change click keyup input paste', function () {
				validateZip();
			});
		});

		$nextBtn.click(function (e) {
			e.preventDefault();
			if (validateZip()) {
				localStorage.setItem('zipcode', state.zip);
				location.href = $(this).attr('href');
			}
		});



	}

	function FloorPlansPage () {
		state.stories = $('.sb-big-radio__input[name="stories"]:checked').val() || null;
		state.sqft = $('.sb-big-radio__input[name="sqft"]:checked').val() || null;
		state.size = null;
		state.schedule = null;
		state.nextUrl = null;

		let $nextBtn = $('.sb-quiz-page__next-btn');
		let $bigRadioInput = $('.sb-big-radio__input');
		let $description = $(".sb-quiz-page__description");

		if (!state.zip) {
			location.href = '/pages/zip-code';
			return false;
		}

		function updateNextUrl () {
			// Get size
			(state.stories == 'single_story' && state.sqft == 'less_2000') ? state.size = 1 : null;
			(state.stories == 'multi_story' && state.sqft == 'less_2000') ? state.size = 1 : null;
			(state.stories == 'multi_story' && state.sqft == '2000_5000') ? state.size = 1 : null;
			(state.stories == 'single_story' && state.sqft == '2000_5000') ? state.size = 2 : null;
			(state.stories == 'multi_story' && state.sqft == 'more_5000') ? state.size = 2 : null;
			(state.stories == 'single_story' && state.sqft == 'more_5000') ? state.size = 3 : null;

			// Get URL from size & schedule
			(state.size == 1 && state.schedule == 'Bi-monthly') ? state.nextUrl = '/products/HS1-BM-PAYG' : null;
			(state.size == 2 && state.schedule == 'Bi-monthly') ? state.nextUrl = '/products/HS2-BM-12MO' : null;
			(state.size == 3 && state.schedule == 'Bi-monthly') ? state.nextUrl = '/products/HS3-BM-12MO' : null;
			(state.size == 1 && state.schedule == 'Monthly') ? state.nextUrl = '/products/HS1-MO-PAYG' : null;
			(state.size == 2 && state.schedule == 'Monthly') ? state.nextUrl = '/products/HS2-MO-12MO' : null;
			(state.size == 3 && state.schedule == 'Monthly') ? state.nextUrl = '/products/HS3-MO-12MO' : null;

			$nextBtn.attr('href', state.nextUrl).removeClass('disabled');
		}

		$.get( "//www.getpestremedy.com/cdn/shop/t/22/assets/zipcodes.json?v=120884804956811048891773269411", function( data ) {
			let entry = data.find(item => item.zip == state.zip);
			let schedule = entry["Shipment Schedule"];
			let city = entry["primary_city"];
			let _state = entry["state"];

			if (!entry || !schedule) {
				location.href = '/pages/zip-code';
			} else if (schedule == 'No shipment') {
				location.href = '/pages/zip-code?noship=true';
			}

			state.schedule = schedule;
			$description.html($description.html().replace('.', ' in '+city+', '+_state+'.'));

		}).done(updateNextUrl).fail(function () {
			location.href = '/pages/zip-code';
		});

		$bigRadioInput.change(function () {
			if ($(this).attr('name') == 'stories') {
				state.stories = $(this).val();
			}
			if ($(this).attr('name') == 'sqft') {
				state.sqft = $(this).val();
			}

			updateNextUrl();
			console.log(state);
		});
	}

	QuoteForm();
	if (location.href.indexOf('/pages/zip-code') > -1) {
		ZipPage();
	}
	if (location.href.indexOf('/pages/floor-plans') > -1) {
		FloorPlansPage();
	}

});




// T&C Checkbox
$(document).ready(function() {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("You must agree with the terms and conditions of sales to check out.");
      return false;
    }
  });
});

// Bug options
$(document).ready(function() {
  $('body').on('change', '#bug-option', function(e) {
    const optionText = e.target.value.toString() || '';
    window
      .fetch(`${window.theme.routes.cart}/update.js`, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          attributes: {
            'bug_option': optionText
          }  
        }),
      })
      .catch((e) => {
        console.error(e);
      });
  });
});




// TRIGGER CART DRAWER ON ATC

function cartDrawer () {
	const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');

	const onSuccess = function (e) {
		document.addEventListener('theme:cart:change', onChange);
	};

	const onChange = function (e) {
		cartDrawer.dispatchEvent(
			new CustomEvent('theme:drawer:open', {
				bubbles: false,
			})
		);
		document.removeEventListener('theme:cart:change', onChange);
	};

	if (cartDrawer) {
		document.addEventListener('theme:cart:success', onSuccess);
	}
}

$(document).ready(function () {
	cartDrawer();
})







